import { MyBloodPressureContent } from "./myBloodPressure";

export const MyBloodPressure = MyBloodPressureContent;
